import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import Header from "../components/Header";

const Section = ({ title, children, id }) => (
  <section className="mb-9" id={id}>
    <h2 className="text-xl font-medium text-[#2C2123] mb-3">{title}</h2>
    <div className="text-[#3C2F33] leading-relaxed space-y-3">{children}</div>
  </section>
);

const mailLink = (
  <a href="mailto:hello@trubeaute.com" className="text-[#9B6A6C] underline" />
);

const Terms = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen trubeaute-gradient">
      <Header />
      <main
        className="pt-32 pb-24 px-6 max-w-3xl mx-auto"
        data-testid="terms-page"
      >
        <span className="inline-block text-xs uppercase tracking-[0.25em] text-[#9B6A6C] mb-3">
          {t("terms.kicker")}
        </span>
        <h1 className="text-4xl font-light text-[#2C2123] leading-tight mb-2">
          {t("terms.headline")}
        </h1>
        <p className="text-[#8A7D82] mb-6 text-sm">
          {t("terms.lastUpdated")}: August 2026
        </p>

        <p className="text-[#3C2F33] leading-relaxed mb-8">
          <Trans i18nKey="terms.intro" components={{ mail: mailLink }} />
        </p>

        <Section title={t("terms.whatItIs.title")} id="what-it-is">
          <p>{t("terms.whatItIs.body")}</p>
        </Section>

        <Section title={t("terms.who.title")} id="who">
          <p>
            <Trans
              i18nKey="terms.who.body1"
              components={{ strong: <strong />, em: <em /> }}
            />
          </p>
          <p>
            <Trans
              i18nKey="terms.who.body2"
              components={{ strong: <strong /> }}
            />
          </p>
          <p>
            <Trans i18nKey="terms.who.body3" components={{ mail: mailLink }} />
          </p>
        </Section>

        <Section title={t("terms.aiDisclaimer.title")} id="ai-disclaimer">
          <p>{t("terms.aiDisclaimer.body1")}</p>
          <p>{t("terms.aiDisclaimer.body2")}</p>
        </Section>

        <Section title={t("terms.account.title")} id="account">
          <p>{t("terms.account.body1")}</p>
          <p>{t("terms.account.body2")}</p>
        </Section>

        <Section title={t("terms.payments.title")} id="payments">
          <p>{t("terms.payments.body1")}</p>
          <p>
            <Trans
              i18nKey="terms.payments.body2"
              components={{ mail: mailLink }}
            />
          </p>
        </Section>

        <Section title={t("terms.affiliate.title")} id="affiliate">
          <p>
            <Trans
              i18nKey="terms.affiliate.body"
              components={{ strong: <strong /> }}
            />
          </p>
        </Section>

        <Section title={t("terms.yourContent.title")} id="your-content">
          <p>{t("terms.yourContent.body1")}</p>
          <p>{t("terms.yourContent.body2")}</p>
        </Section>

        <Section title={t("terms.conduct.title")} id="conduct">
          <ul className="list-disc list-inside space-y-1">
            <li>{t("terms.conduct.item1")}</li>
            <li>{t("terms.conduct.item2")}</li>
            <li>{t("terms.conduct.item3")}</li>
            <li>{t("terms.conduct.item4")}</li>
          </ul>
          <p>{t("terms.conduct.outro")}</p>
        </Section>

        <Section title={t("terms.privacySection.title")} id="privacy">
          <p>
            <Trans
              i18nKey="terms.privacySection.body"
              components={{
                pl: (
                  <Link to="/privacy" className="text-[#9B6A6C] underline" />
                ),
                sl: (
                  <Link to="/settings" className="text-[#9B6A6C] underline" />
                ),
              }}
            />
          </p>
        </Section>

        <Section title={t("terms.changes.title")} id="changes">
          <p>{t("terms.changes.body")}</p>
        </Section>

        <Section title={t("terms.liability.title")} id="liability">
          <p>{t("terms.liability.body1")}</p>
          <p>{t("terms.liability.body2")}</p>
        </Section>

        <Section title={t("terms.disputes.title")} id="disputes">
          <p>
            <Trans
              i18nKey="terms.disputes.body"
              components={{ mail: mailLink }}
            />
          </p>
        </Section>

        <Section title={t("terms.closing.title")} id="closing">
          <p>{t("terms.closing.body")}</p>
          <p className="italic text-[#5C4B51]">{t("terms.closing.signoff")}</p>
        </Section>
      </main>
    </div>
  );
};

export default Terms;
